import { GeoLocationDataModel } from "@models/location";
import { useEffect, useState } from "react";

const useIpAddress = () => {
  const [geoLocationData, setGeoLocationData] =
    useState<GeoLocationDataModel | null>(null);

  const [isLoadingLocation, setIsLocationLoading] = useState(true);

  useEffect(() => {
    const ipURL = "https://ipinfo.io/?token=9375d42c60594e";
    fetch(ipURL)
      .then((response) => response.json())
      .then((data) => {
        setGeoLocationData(data);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      })
      .finally(() => {
        setIsLocationLoading(false);
      });
  }, []);

  return { geoLocationData, isLoadingLocation };
};

export default useIpAddress;
